/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 1/23/2019.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import { Card } from '@scuf/common';
import {withRouter} from "react-router";
import FleetChart from '../common/FleetChart';
import {fetchSingleFleet} from '../api/Fleets';
class FleetCard extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            fleet: null,
        }
    }

    componentDidMount() {
        const {fleet} = this.props
        const me = this
        fetchSingleFleet(fleet.id).then((response) => {
            me.setState({fleet: response})
        })
    }

    goToFleet(fleet) {
        const {history} = this.props
        history.push(`/fleets/${fleet.id}`)
    }

    getAttributesComponents() {
        const fleet = this.state.fleet
        const attrs = []
        const hasSubfleets = fleet.subfleetCount > 0

        if (hasSubfleets) {
            attrs.push(this.getAttributeRow('subfleetCount', fleet.subfleetCount))
        }
        attrs.push(this.getAttributeRow('assetCount', fleet.assetCount))
        attrs.push(this.getAttributeRow('faultsCount', fleet.faultsCount))

        const assetsWithFaults = fleet.assetsFaultStatesCount.length;
        attrs.push(this.getAttributeRow('assetsNoFaultCount', fleet.assetCount - assetsWithFaults, 'faults-CLOSED mobile only'))
        attrs.push(this.getAttributeRow('assetsWithFaultCount', assetsWithFaults, 'faults-NEW mobile only'))

        return <div>{attrs}</div>
    }

    getAttributeRow(key, value, cls) {
        const {intl} = this.props
        const name = intl.formatMessage({id: 'fleet.attr.' + key})
        return <div key={key} className={"attr " + key + (cls ? (' ' + cls) : '')}><span className="attr-name">{name}:</span><span className="attr-value">{value}</span></div>
    }

    render() {
        if (this.state.fleet == null) {
            return null
        }
        return (
            <Card onClick={() => this.goToFleet(this.state.fleet)} className={'fleet-card'}>
                <Card.Header>
                    <div className='fault-name' title={this.state.fleet.name}>{this.state.fleet.name}</div>
                </Card.Header>
                <Card.Content>
                    <div className="attrs">
                        {this.getAttributesComponents()}
                    </div>
                    <div className="chart">
                        <FleetChart fleet={this.state.fleet} height={200}/>
                    </div>
                </Card.Content>
            </Card>
        )
    }
}

export default injectIntl(withRouter((FleetCard)))